/* eslint-disable jsx-a11y/anchor-is-valid */
import type { RootState } from '@/store/store';
import type { FC } from 'react';

import classNames from 'classnames';
import { Select, Sidebar } from 'flowbite-react'; // , Tooltip, Dropdown
import {
  HiBell,
  // HiAdjustments,
  HiChartPie,
  HiChartSquareBar,
  HiClipboard,
  HiCog,
  HiInformationCircle,
  HiUserGroup,
} from 'react-icons/hi';

import { useAppDispatch } from '@/store/hooks';
import { selectActiveOrganization } from '@/store/organization/organizationSlice';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { useSidebarContext } from '../context/SidebarContext';
import isSmallScreen from '../helpers/is-small-screen';

const ExampleSidebar: FC = () => {
  const { isOpenOnSmallScreens: isSidebarOpenOnSmallScreens } =
    useSidebarContext();
  // const [isUsersOpen, setUsersOpen] = useState(true);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { organizations, selectedOrganization } = useSelector(
    (state: RootState) => state.organization
  );

  const meIsSuperUser = useSelector(
    (state: RootState) => Boolean(state.auth.user?.is_staff)
  );

  const onChangeSelectedOrganization = ({
    target: { options },
  }: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIndex = options.selectedIndex;

    const slug = options?.[selectedIndex as number]?.getAttribute?.(
      'data-slug'
    ) as string;

    dispatch(selectActiveOrganization(slug));
  };

  const disableButtonIfNoOrganizations = () => {
    if (organizations?.length) return '';
    return 'opacity-50 pointer-events-none';
  };

  return (
    <div
      className={classNames('lg:!block z-50', {
        hidden: !isSidebarOpenOnSmallScreens,
      })}
    >
      <Sidebar
        className="pointer-events-none"
        collapsed={isSidebarOpenOnSmallScreens && !isSmallScreen()}
      >
        <div className="pointer-events-all flex h-full w-full flex-col items-start overflow-hidden py-2">
          <div className="mb-2 w-full">
            <Select
              value={selectedOrganization?.name ?? 'Нет команды'}
              onChange={onChangeSelectedOrganization}
              addon={
                <HiCog
                  size="20"
                  onClick={() => navigate('/my-teams')}
                  className="shrink-0 grow cursor-pointer transition-transform hover:scale-110"
                />
              }
              id="countries"
              required
            >
              {(organizations ?? []).map(({ name, slug }, index) => (
                <option data-slug={slug} key={index}>
                  {name}
                </option>
              ))}
            </Select>
          </div>
          {/* <form className="pb-3 md:hidden">
            <TextInput
              icon={HiSearch}
              type="search"
              placeholder="Search"
              required
              size={32}
            />
          </form> */}
          <Sidebar.Items>
            <Sidebar.ItemGroup>
              <Sidebar.Collapse icon={HiChartPie} label="Дашборд">
                <Sidebar.Item
                  icon={HiChartPie}
                  onClick={() => navigate('/dashboard-search')}
                  className={
                    '/dashboard-search' === location.pathname
                      ? 'bg-gray-100 dark:bg-gray-700'
                      : '' + disableButtonIfNoOrganizations()
                  }
                >
                  Поиск / Каталог
                </Sidebar.Item>
                {/* <Sidebar.Item
                  icon={HiChartPie}
                  // onClick={() => navigate('/dashboard-search')}
                  // className={
                  //   '/dashboard/search' === location.pathname
                  //     ? 'bg-gray-100 dark:bg-gray-700'
                  //     : '' + disableButtonIfNoOrganizations()
                  // }
                >
                  Анализ Цен
                </Sidebar.Item>
                <Sidebar.Item
                  icon={HiChartPie}
                  // onClick={() => navigate('/dashboard-search')}
                  // className={
                  //   '/dashboard/search' === location.pathname
                  //     ? 'bg-gray-100 dark:bg-gray-700'
                  //     : '' + disableButtonIfNoOrganizations()
                  // }
                >
                  Анализ Цен
                </Sidebar.Item> */}
              </Sidebar.Collapse>

              <Sidebar.Collapse
                icon={HiChartSquareBar}
                className={disableButtonIfNoOrganizations()}
                label="Отчеты"
              >
                <Sidebar.Item
                  icon={HiChartPie}
                  onClick={() => navigate('/reports/goods')}
                  className={
                    '/reports/goods' === location.pathname
                      ? 'bg-gray-100 dark:bg-gray-700'
                      : '' + disableButtonIfNoOrganizations()
                  }
                >
                  Товары
                </Sidebar.Item>
              </Sidebar.Collapse>

              <Sidebar.Item
                className={disableButtonIfNoOrganizations()}
                icon={HiBell}
              >
                Оповещения
              </Sidebar.Item>
            </Sidebar.ItemGroup>
            <Sidebar.ItemGroup>
              <Sidebar.Item
                onClick={() => navigate('/')}
                className={
                  '/' === location.pathname
                    ? 'bg-gray-100 dark:bg-gray-700'
                    : '' + disableButtonIfNoOrganizations()
                }
                icon={HiCog}
              >
                Управление
              </Sidebar.Item>
              {meIsSuperUser && (
                <Sidebar.Item
                  onClick={() => navigate('/reparse')}
                  className={
                    '/reparse' === location.pathname
                      ? 'bg-gray-100 dark:bg-gray-700'
                      : '' + disableButtonIfNoOrganizations()
                  }
                  icon={HiCog}
                >
                  Перепарсинг
                </Sidebar.Item>
              )}
              {meIsSuperUser && (
                <Sidebar.Item
                  onClick={() => navigate('/settings-transfer')}
                  className={
                    '/settings-transfer' === location.pathname
                      ? 'bg-gray-100 dark:bg-gray-700'
                      : '' + disableButtonIfNoOrganizations()
                  }
                  icon={HiCog}
                >
                  Экспорт/Импорт
                </Sidebar.Item>
              )}
            </Sidebar.ItemGroup>
            <Sidebar.ItemGroup>
              <Sidebar.Item
                onClick={() => navigate('/my-teams')}
                className={
                  '/my-teams' === location.pathname
                    ? 'bg-gray-100 dark:bg-gray-700'
                    : ''
                }
                icon={HiUserGroup}
              >
                Мои Команды
              </Sidebar.Item>
            </Sidebar.ItemGroup>
            <Sidebar.ItemGroup>
              <Sidebar.Item
                // href="https://github.com/themesberg/flowbite-react/"
                icon={HiClipboard}
              >
                Документация
              </Sidebar.Item>
              <Sidebar.Item
                // href="https://github.com/themesberg/flowbite-react/issues"
                icon={HiInformationCircle}
              >
                Помощь
              </Sidebar.Item>
            </Sidebar.ItemGroup>
          </Sidebar.Items>

          {/*<BottomMenu />*/}
        </div>
      </Sidebar>
    </div>
  );
};

// const BottomMenu: FC = function () {
//   return (
//     <div className="flex items-center justify-center gap-x-5">
//       <button className="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-gray-700">
//         <span className="sr-only">Tweaks</span>
//         <HiAdjustments className="text-2xl text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white " />
//       </button>
//       <div>
//         <Tooltip content="Settings page">
//           <a
//             href="/users/settings"
//             className="inline-flex cursor-pointer justify-center rounded p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 dark:hover:text-white"
//           >
//             <span className="sr-only">Settings page</span>
//             <HiCog className="text-2xl text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white" />
//           </a>
//         </Tooltip>
//       </div>
//       <div>
//         <LanguageDropdown />
//       </div>
//     </div>
//   );
// };

// const LanguageDropdown: FC = function () {
// //   return (
// //     <Dropdown
// //       arrowIcon={false}
// //       inline
// //       label={
// //         <span className="inline-flex cursor-pointer justify-center rounded p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 dark:hover:text-white">
// //           <span className="sr-only">Current language</span>
// //           <svg
// //             xmlns="http://www.w3.org/2000/svg"
// //             xmlnsXlink="http://www.w3.org/1999/xlink"
// //             viewBox="0 0 3900 3900"
// //             className="h-5 w-5 rounded-full"
// //           >
// //             <path fill="#b22234" d="M0 0h7410v3900H0z"></path>
// //             <path
// //               d="M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0"
// //               stroke="#fff"
// //               strokeWidth="300"
// //             ></path>
// //             <path fill="#3c3b6e" d="M0 0h2964v2100H0z"></path>
// //             <g fill="#fff">
// //               <g id="d">
// //                 <g id="c">
// //                   <g id="e">
// //                     <g id="b">
// //                       <path
// //                         id="a"
// //                         d="M247 90l70.534 217.082-184.66-134.164h228.253L176.466 307.082z"
// //                       ></path>
// //                       <use xlinkHref="#a" y="420"></use>
// //                       <use xlinkHref="#a" y="840"></use>
// //                       <use xlinkHref="#a" y="1260"></use>
// //                     </g>
// //                     <use xlinkHref="#a" y="1680"></use>
// //                   </g>
// //                   <use xlinkHref="#b" x="247" y="210"></use>
// //                 </g>
// //                 <use xlinkHref="#c" x="494"></use>
// //               </g>
// //               <use xlinkHref="#d" x="988"></use>
// //               <use xlinkHref="#c" x="1976"></use>
// //               <use xlinkHref="#e" x="2470"></use>
// //             </g>
// //           </svg>
// //         </span>
// //       }
// //     >
// //       <ul className="py-1" role="none">
// //         <li>
// //           <a
// //             href="#"
// //             className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
// //           >
// //             <div className="inline-flex items-center">
// //               <svg
// //                 className="mr-2 h-4 w-4 rounded-full"
// //                 xmlns="http://www.w3.org/2000/svg"
// //                 id="flag-icon-css-us"
// //                 viewBox="0 0 512 512"
// //               >
// //                 <g fillRule="evenodd">
// //                   <g strokeWidth="1pt">
// //                     <path
// //                       fill="#bd3d44"
// //                       d="M0 0h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0z"
// //                       transform="scale(3.9385)"
// //                     />
// //                     <path
// //                       fill="#fff"
// //                       d="M0 10h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0zm0 20h247v10H0z"
// //                       transform="scale(3.9385)"
// //                     />
// //                   </g>
// //                   <path
// //                     fill="#192f5d"
// //                     d="M0 0h98.8v70H0z"
// //                     transform="scale(3.9385)"
// //                   />
// //                   <path
// //                     fill="#fff"
// //                     d="M8.2 3l1 2.8H12L9.7 7.5l.9 2.7-2.4-1.7L6 10.2l.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7L74 8.5l-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 7.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 24.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 21.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 38.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 35.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 52.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 49.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm-74.1 7l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7H65zm16.4 0l1 2.8H86l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm-74 7l.8 2.8h3l-2.4 1.7.9 2.7-2.4-1.7L6 66.2l.9-2.7-2.4-1.7h3zm16.4 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8H45l-2.4 1.7 1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9zm16.4 0l1 2.8h2.8l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h3zm16.5 0l.9 2.8h2.9l-2.3 1.7.9 2.7-2.4-1.7-2.3 1.7.9-2.7-2.4-1.7h2.9zm16.5 0l.9 2.8h2.9L92 63.5l1 2.7-2.4-1.7-2.4 1.7 1-2.7-2.4-1.7h2.9z"
// //                     transform="scale(3.9385)"
// //                   />
// //                 </g>
// //               </svg>
// //               <span className="whitespace-nowrap">English (US)</span>
// //             </div>
// //           </a>
// //         </li>
// //         <li>
// //           <a
// //             href="#"
// //             className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
// //           >
// //             <div className="inline-flex items-center">
// //               <svg
// //                 className="mr-2 h-4 w-4 rounded-full"
// //                 xmlns="http://www.w3.org/2000/svg"
// //                 id="flag-icon-css-de"
// //                 viewBox="0 0 512 512"
// //               >
// //                 <path fill="#ffce00" d="M0 341.3h512V512H0z" />
// //                 <path d="M0 0h512v170.7H0z" />
// //                 <path fill="#d00" d="M0 170.7h512v170.6H0z" />
// //               </svg>
// //               Deutsch
// //             </div>
// //           </a>
// //         </li>
// //         <li>
// //           <a
// //             href="#"
// //             className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
// //           >
// //             <div className="inline-flex items-center">
// //               <svg
// //                 className="mr-2 h-4 w-4 rounded-full"
// //                 xmlns="http://www.w3.org/2000/svg"
// //                 id="flag-icon-css-it"
// //                 viewBox="0 0 512 512"
// //               >
// //                 <g fillRule="evenodd" strokeWidth="1pt">
// //                   <path fill="#fff" d="M0 0h512v512H0z" />
// //                   <path fill="#009246" d="M0 0h170.7v512H0z" />
// //                   <path fill="#ce2b37" d="M341.3 0H512v512H341.3z" />
// //                 </g>
// //               </svg>
// //               Italiano
// //             </div>
// //           </a>
// //         </li>
// //         <li>
// //           <a
// //             href="#"
// //             className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
// //           >
// //             <div className="inline-flex items-center">
// //               <svg
// //                 className="mr-2 h-4 w-4 rounded-full"
// //                 xmlns="http://www.w3.org/2000/svg"
// //                 xmlnsXlink="http://www.w3.org/1999/xlink"
// //                 id="flag-icon-css-cn"
// //                 viewBox="0 0 512 512"
// //               >
// //                 <defs>
// //                   <path id="a" fill="#ffde00" d="M1-.3L-.7.8 0-1 .6.8-1-.3z" />
// //                 </defs>
// //                 <path fill="#de2910" d="M0 0h512v512H0z" />
// //                 <use
// //                   width="30"
// //                   height="20"
// //                   transform="matrix(76.8 0 0 76.8 128 128)"
// //                   xlinkHref="#a"
// //                 />
// //                 <use
// //                   width="30"
// //                   height="20"
// //                   transform="rotate(-121 142.6 -47) scale(25.5827)"
// //                   xlinkHref="#a"
// //                 />
// //                 <use
// //                   width="30"
// //                   height="20"
// //                   transform="rotate(-98.1 198 -82) scale(25.6)"
// //                   xlinkHref="#a"
// //                 />
// //                 <use
// //                   width="30"
// //                   height="20"
// //                   transform="rotate(-74 272.4 -114) scale(25.6137)"
// //                   xlinkHref="#a"
// //                 />
// //                 <use
// //                   width="30"
// //                   height="20"
// //                   transform="matrix(16 -19.968 19.968 16 256 230.4)"
// //                   xlinkHref="#a"
// //                 />
// //               </svg>
// //               <span className="whitespace-nowrap">中文 (繁體)</span>
// //             </div>
// //           </a>
// //         </li>
// //       </ul>
// //     </Dropdown>
// //   );
// // };

export default ExampleSidebar;
